import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import WearablesStrip from "@/components/WearablesStrip";
import DailyPicture from "@/components/DailyPicture";
import SleepRecovery from "@/components/SleepRecovery";
import ActivityStrain from "@/components/ActivityStrain";
import AICoach from "@/components/AICoach";
import InteractiveDemo from "@/components/InteractiveDemo";
import FeatureGrid from "@/components/FeatureGrid";
import InShopMode from "@/components/InShopMode";
import Glp1Tracker from "@/components/Glp1Tracker";
import Testimonials from "@/components/Testimonials";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <main className="bg-zoku-bg text-zoku-ink overflow-x-hidden" data-testid="landing-page">
      <Navbar />
      <Hero />
      <WearablesStrip />
      <DailyPicture />
      <SleepRecovery />
      <ActivityStrain />
      <AICoach />
      <InteractiveDemo />
      <Glp1Tracker />
      <FeatureGrid />
      <InShopMode />
      <Testimonials />
      <FinalCTA />
      <Footer />
    </main>
  );
}
